import { Tekster } from "./types/apptekster";
import { createApptekstContext } from "svv-hradm-apptekster-react";

const { ApptekstProvider, useApptekster } = createApptekstContext<Tekster>();

export {
  ApptekstProvider,
  useApptekster,
};